import { FC } from 'react'

import { ISvgClass } from '../interface'

const ArrowRightIcon: FC<ISvgClass> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="7"
      height="10"
      viewBox="0 0 7 10"
      fill="none"
      {...props}
    >
      <path
        d="M2.0002 0L0.825195 1.175L4.64186 5L0.825195 8.825L2.0002 10L7.0002 5L2.0002 0Z"
        fill="inherit"
      />
    </svg>
  )
}

export default ArrowRightIcon
